import useMediaQuery from './useMediaQuery';

export default function useIsMobile() {
    const { isMobile } = useMediaQuery();

    return isMobile;
}
